/**
 * The stored answer key of a word ladder: the author's own ladder. Kept apart from the editor
 * component so the eagerly loaded module file never pulls the form into the bundle.
 */
import type { WordLadderDefinition, WordLadderSolution } from "./types";

export function emptySolution(definition: WordLadderDefinition): WordLadderSolution {
  return { ladder: [definition.start, definition.end] };
}

/** Reads whatever is stored, however wrong, and keeps the strings it can use. */
export function ladderOf(value: unknown): string[] {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return [];
  const ladder = (value as Record<string, unknown>).ladder;
  if (!Array.isArray(ladder)) return [];
  return ladder.filter((word): word is string => typeof word === "string");
}
